export default __webpack_public_path__ + "static/media/machine4.d7974849.png";